import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, Toolbar, Button, TagList, Row,
  TabBar, IconFold, FormattedDate, DataTable
} from '../components'

const SCOPE_ACCESS_TOKENS = 'access'
const SCOPE_REFRESH_TOKENS = 'refresh'

export default class Tokens extends React.Component {
    state = {
        url: 'api/tokens/access'
    }

    tabs = [
        ['access', 'Access Tokens'],
        ['refresh', 'Refresh Tokens']
    ]

    static contextTypes = {
        config: PropTypes.object.isRequired
    }

    onRenderHeader = () => (
        <tr>
            <th className="table-30p"></th>
            <th className="table-200p">{i18n('tokens.client-id')}</th>
            <th>{i18n('tokens.token')}</th>
            <th>{i18n('tokens.scopes')}</th>
            <th className="table-200p txtcenter">{i18n('tokens.expiration')}</th>
            <th className="table-200p txtcenter"><i className="icon fa fa-pencil" /></th>
        </tr>
    )

    onRenderRow = (item, index) => (
        <Row key={index}>
            <td><IconFold /></td>
            <td>{item.clientId}</td>
            <td>{item.value}</td>
            <td><TagList items={item.scopes} store={this.context.config} /></td>
            <td className="txtcenter"><FormattedDate>{item.expiration}</FormattedDate></td>
            <td className="table-actions">
                <a href="#" className="btn btn--danger"><i className="fa fa-trash" />&nbsp;&nbsp;Revoke</a>
            </td>
        </Row>
    )

    onScopeChange = (value) => {
        const routes = {
            [SCOPE_ACCESS_TOKENS]: 'api/tokens/access',
            [SCOPE_REFRESH_TOKENS]: 'api/tokens/refresh'
        }

        this.setState({url: routes[value]})
    }


    render() {
        return (
            <div>
                <TabBar
                    buttons={this.tabs}
                    onChange={this.onScopeChange}
                />

                <Box>
                    <DataTable
                        url={this.state.url}
                        onRenderHeader={this.onRenderHeader}
                        onRenderRow={this.onRenderRow}
                    />
                </Box>
            </div>
        )
    }
}
